import * as s from './style'

function Banner(){
    return(
        <s.container>
            <div className='banner'>
                <div className='container-text'>
                    <h1>SifraPag</h1>
                    <p>
                        Seja bem-vindo novamente. Estamos <br/>
                        felizes em lhe ver ☺
                    </p>
                </div>
                <div className='container-img'>
                    <img alt='' loading='lazy' src='https://comprar.bagy.com.br/_next/static/images/girl-with-pc-036942294fc2124676113a87bbfc3be4.svg'/>
                </div>
            </div>
        </s.container>
    )
}


export default Banner